// Module
var code = `{{#visibleIdea}}
<div class="terceraTicketViewerIdea" on-click="OnClickIdea" as-tooltip="dealTicketTooltipIdea">
    <div class="ticket-viewer-column">
        <svg class="{{.headerClass}}">
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{imageSvg}}"></use>
        </svg>
    </div>
    <div class="ticket-viewer-column">
        <div class="js-TicketViewer-header {{.headerClassIdea}}">{{.headerIdea}}</div>
        <div class="js-TicketViewer-text">{{.textIdea}}</div>
    </div>
</div>
{{/}}

{{#visible}}
<div class="terceraTicketViewer" on-click="OnClick" as-tooltip="dealTicketTooltip">
    <div class="ticket-viewer-column">
        <svg class="{{.headerClass}}">
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{imageSvg}}"></use>
        </svg>
    </div>
    <div class="ticket-viewer-column">
        <div class="js-TicketViewer-header {{.headerClass}}">{{.header}}</div>
        <div class="js-TicketViewer-text">{{.text}}</div>
    </div>
</div>
{{/}}`;
// Exports
export default code;